import Items from './Items'

module.exports = Items.reducer( null, 'USER', '/', [ '/' ] )
